import { registerPuzzle } from '@/engine/loader';
import { chapter1Puzzles } from './journey/chapter1';
import { chapter2Puzzles } from './journey/chapter2';
import { chapter3Puzzles } from './journey/chapter3';
import { chapter4Puzzles } from './journey/chapter4';
import { chapter5Puzzles } from './journey/chapter5';
import { chapter6Puzzles } from './journey/chapter6';
import { chapter7Puzzles } from './journey/chapter7';

/**
 * Registers all puzzle definitions with the loader registry.
 * Call this once at app startup.
 */
export function registerAllPuzzles(): void {
  for (const puzzle of chapter1Puzzles) {
    registerPuzzle(puzzle);
  }
  for (const puzzle of chapter2Puzzles) {
    registerPuzzle(puzzle);
  }
  for (const puzzle of chapter3Puzzles) {
    registerPuzzle(puzzle);
  }
  for (const puzzle of chapter4Puzzles) {
    registerPuzzle(puzzle);
  }
  for (const puzzle of chapter5Puzzles) {
    registerPuzzle(puzzle);
  }
  for (const puzzle of chapter6Puzzles) {
    registerPuzzle(puzzle);
  }
  for (const puzzle of chapter7Puzzles) {
    registerPuzzle(puzzle);
  }
}
